import styled, { keyframes } from 'styled-components';
import colors from '../../assets/styles/colors';

const rotating = keyframes`
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

export const ModalActionContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
`;

export const ModalActionContent = styled.div`
  width: 100%;
  max-width: 650px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalActionHead = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${prop => prop.setShowModal ? '0' : '30px'};

  svg {
    cursor: pointer;
  }
`;

export const ModalActionBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const ModalActionBodyIcon = styled.div`
  width: 67px;
  height: 67px;
  background: ${prop => prop.backgroundIcon ? prop.backgroundIcon : 'transparent'};
  box-shadow: ${prop => prop.backgroundIcon ? `0px 5px 10px ${colors.shadow}` : 'none'};
  -webkit-box-shadow: ${prop => prop.backgroundIcon ? `0px 5px 10px ${colors.shadow}` : 'none'};
  -moz-box-shadow: ${prop => prop.backgroundIcon ? `0px 5px 10px ${colors.shadow}` : 'none'};
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    -webkit-animation: ${prop => prop.rotateIcon && !prop.backgroundIcon && rotating} 1s linear infinite;
    -moz-animation: ${prop => prop.rotateIcon && !prop.backgroundIcon && rotating} 1s linear infinite;
    -ms-animation: ${prop => prop.rotateIcon && !prop.backgroundIcon &&rotating} 1s linear infinite;
    -o-animation: ${prop => prop.rotateIcon && !prop.backgroundIcon &&rotating} 1s linear infinite;
    animation: ${prop => prop.rotateIcon && !prop.backgroundIcon &&rotating} 1s linear infinite;
  }
`;

export const ModalActionBodyLabel = styled.p`
  text-align: center;
  margin-top: 30px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${colors.black};
`;

export const ModalActionBodyDescription = styled.p`
margin-top: 20px;
  max-width: 521px;
  font-size: 16px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: center;
`;

export const ModalActionFooterButton = styled.button`
  margin: 20px;
  padding-top: 10px;
  padding-bottom: 25px;
  padding-left: 50px;
  padding-right: 50px;
  max-width: 292px;
  height: 32px;
  letter-spacing: 0.03em;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  border-radius: 48px;
  transition: .2s;

  &#top-action-button {
    background: ${colors.bgPrimary};
    color: ${colors.white};
    box-shadow: 0px 5px 10px ${colors.shadow};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
    -moz-box-shadow: 0px 5px 10px ${colors.shadow};
    border: 1px solid ${colors.bgPrimaryLight};

    &:hover {
      background: ${colors.bgPrimaryHover};
      border: 1px solid ${colors.bgPrimaryLight};
      box-shadow: 0px 5px 15px ${colors.shadowHover};
      -webkit-box-shadow: 0px 5px 10px ${colors.shadowHover};
      -moz-box-shadow: 0px 5px 10px ${colors.shadowHover};
    }
  }

  &#bottom-action-button {
    margin-top: 20px;
    background: ${colors.white};
    border: 1px solid #9CA1AE;
    box-shadow: 0px 5px 10px ${colors.shadow};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
    -moz-box-shadow: 0px 5px 10px ${colors.shadow};
    color: ${colors.textPrimary};

    &:hover {
      box-shadow: 0px 5px 15px ${colors.shadowHover};
      -webkit-box-shadow: 0px 5px 10px ${colors.shadowHover};
      -moz-box-shadow: 0px 5px 10px ${colors.shadowHover};
    }
  }
`;
